
        import 'YourPlan.095d13f.css-module'
        export default {"YourPlan":"YourPlan_YourPlan_095d13f"}
    